import { createContext } from 'react';

/**
 * 🔒 Whether a split Button lays its other entries out as buttons of their own beside it, rather than behind its
 * chevron (T2190; decision 3052). A phone's document footer turns it on when it draws a More, so Send keeps Send
 * and Mark as sent joins More after it; everywhere else it is off.
 *
 * 🔨 A Modal turns it off again for everything inside it, so a window opened from that footer keeps its own split
 * Primary whole. 🔨 A destructive split never lays out its entries, because each rides its confirmation.
 *
 * It lives apart from the Button so the Modal shell can read it without importing the Button that imports the shell.
 */
export const SplitAsButtonsContext = createContext(false);
